import httpService from "./httpService";
import httpServiceMain from "./httpServiceMain";

interface NestedObject {
  [key: string]: string | string[];
}

interface SerializeObject {
  [key: string]: string | NestedObject;
}

export const serialize = function (obj: SerializeObject): string {
  const searchParams = new URLSearchParams();
  for (let key in obj) {
    if (typeof obj[key] === "object" && obj[key] !== null) {
      const nestedObj = obj[key] as NestedObject;
      for (let iKey in nestedObj) {
        const value = nestedObj[iKey];
        if (Array.isArray(value)) {
          value.forEach((arrValue, index) => {
            if (arrValue !== "") searchParams.append(`filter[${iKey}][${index}]`, arrValue);
          });
        } else {
          if (value !== "") searchParams.append(`filter[${iKey}]`, value);
        }
      }
    } else {
      searchParams.append(`${key}`, obj[key] as string);
    }
  }
  return `?${decodeURIComponent(searchParams.toString())}`;
};

export const fetchAchievements = async (lang: string, nickname: string, params: SerializeObject): Promise<any> => {
  const paramsSerialized: string = await serialize(params);
  return await httpService.get(`/${lang}/profile/${nickname}/achievements${paramsSerialized}`);
};

export const fetchFollowing = async (lang: string, nickname: string, params: SerializeObject): Promise<any> => {
  const paramsSerialized = await serialize(params);
  return await httpService.get(`/${lang}/profile/${nickname}/following${paramsSerialized}`);
};

export const fetchFollowers = async (lang: string, nickname: string, params: SerializeObject): Promise<any> => {
  const paramsSerialized = await serialize(params);
  return await httpService.get(`/${lang}/profile/${nickname}/followers${paramsSerialized}`);
};

export const fetchDocuments = async (params: SerializeObject): Promise<any> => {
  const paramsSerialized = await serialize(params);
  return await httpServiceMain.get(`/document-website-latest${paramsSerialized}`);
};

export const follow = async (lang: string, params: any): Promise<any> => {
  return await httpService.post(`/api/${lang}/follow/`, params);
};

export const unfollow = async (lang: string, params: any): Promise<any> => {
  return await httpService.post(`/api/${lang}/unfollow/`, params);
};
